import styled from 'styled-components'
import { Grid } from 'components/Layout'
import { mq } from 'Theme'

export const NavigationWrapper = styled(Grid)`
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  grid-template-rows: ${({ children }) =>
    children.filter(Boolean).reduce((acc) => `auto ${acc}`, '1fr')};
  ${mq.to.TABLET`
    display: block;
  `};
  height: 100%;
`
